import { getFormatDate, getPrevOrNextDate } from "@/util/date"
import { API_AUTH, isNH } from "./config"
import traffic from "@/assets/insights/traffic.svg"
import office from "@/assets/insights/office.svg"
import market from "@/assets/insights/market.svg"
import governmentImg from "@/assets/insights/government.svg"
import park from "@/assets/insights/park.svg"
import school from "@/assets/insights/school.svg"
import quarters from "@/assets/insights/quarters.svg"
import hospital from "@/assets/insights/hospital.svg"
import hotel from "@/assets/insights/hotel.svg"
import {
  BarSex,
  BarPercent,
  Pie,
  PieMore,
  PieHalf,
  Bar,
  BarTop,
  BarRow,
  Chatgpt,
} from "@/pages/Insights/components/BarCharts/bar"
import TreeMap from "@/pages/Insights/components/TreeMap"
import {
  BusinessCooMode,
  BusinessCooStatus,
  CommerceTaxQueryType,
  CompanyPriorityRecommendType,
  FinancingRoundsType,
  FlowFilterType,
  FlowFilterUnit,
  GovQueryType,
  IndustryModuleType,
  RoleAuthStrategy,
  SceneCustomerType,
  SiteAnalysisStatus,
  SiteChooseWay,
  SiteSelectionRestrictionCondition,
  PerformanceCustomerType,
} from "@/api"
// ==============================================
const BarColor: any[] = [
  [
    "rgba(241, 105, 85, 0.2)",
    "rgba(253, 46, 121, 0.2)",
    "rgba(241, 105, 85, 1)",
    "rgba(253, 46, 121, 1)",
  ], // 玫红
  [
    "rgba(228, 26, 255, 0.2)",
    "rgba(34, 61, 255, 0.2)",
    "rgba(228, 26, 255, 1)",
    "rgba(34, 61, 255, 1)",
  ], //紫兰
  [
    "rgba(244, 72, 18, 0.2)",
    "rgba(255, 164, 21, 0.2)",
    "rgba(244, 72, 18, 1)",
    "rgba(255, 164, 21, 1)",
  ], //橘黄 默认
]

const BarTopColor: any[] = [
  ["#009DFF", "#00F1FB"], //蓝色
  ["#E41AFF", "#223DFF"], //默认 紫兰
]

/**
 * 默认半径值
 */
export const defaultRange = 500

/**
 * 农村热力图数据筛选半径
 */
export const ruralHeatRadius = 500

/**
 * 默认不翻页请求数据量
 */
export const defaultLimit = 10000

/**
 * 默认翻页limit
 */
export const paginationLimit = 1000

/**
 * 网点接口limit
 */
export const storeLimit = 50000

/**
 * 默认z-index
 */
export const defaultZIndex = 9999

/**
 * rem的基准值
 */
export const remStatic = parseFloat(document.documentElement.style.fontSize) || 0

/**
 * 显示网点（比例尺5KM对应的zoom）
 */
export const SHOW_SINGLE_STORE_ZOOM = 10

/**
 * 显示icon+text（比例尺500m对应的zoom）
 */
export const SHOW_ICON_TEXT = 13.7

/**
 * 广告行业显示icon+text（比例尺50m对应的zoom）
 */
export const SHOW_ADVERTISEMENT_TEXT = 16.3

/**
 * 地图不同层级zoom
 */
export const showZoomMap = {
  CN: 3,
  PROVINCES: 6,
  CITY: 8,
  DISTRICT: 9,
  TOWNSHIP: 14,
  STORE: 14,
}

/**
 * 地图不同层级offset（位置偏左）
 */
export const offsetMap = {
  CN: 0,
  PROVINCES: 2,
  CITY: 1,
  DISTRICT: 0.5,
  TOWNSHIP: 0,
  STORE: 0.015,
}

/**
 * 地图不同层级offset（位置中心）
 */
export const offsetCenterMap = {
  CN: 0,
  PROVINCES: 1,
  CITY: 0,
  DISTRICT: 0,
  TOWNSHIP: 0.008,
  STORE: 0.015,
}

/**
 * 定位视图偏移量及zoom
 */
export const viewOffset = 0.008
export const viewZoom = 15

/**
 * 定位中心点偏移量及zoom
 */
export const centerOffset = 0.015
export const centerZoom = 14

/**
 * PaginationTable组件pageSizeOptions值
 */
export const pageSizeOptions = [10, 20, 50, 100, 1000]

/**
 * 默认值
 */
export const defaultStringValue = "- -"

/**
 * 日期格式
 */
export const dateFormat = "YYYY-MM-DD"
export const dateCompactFormat = "YYYYMMDD"
export const yearFormat = "YYYY"
export const monthFormat = "YYYY-MM"

/**
 * cityId前缀
 */
export const cityIdPrefix = "401002"

// 自定义数据网点
export const TYPE_CUSTOM_POI = "custom"
// 维智数据网点
export const TYPE_WAYZ_POI = "wayz"

/**
 * 点点通相关数据
 */
export const VIPCODE = [10001, 10002, 10003, 10004]

/**
 * 地图默认初始化参数
 */
export const defaultMapOptions = {
  pitch: 0,
  center: [120.16482, 30.243544],
  longitude: 120.16482,
  latitude: 30.243544,
  zoom: 7,
  maxZoom: 20,
  minZoom: 3,
  bearing: 0,
  rotation: 0,
  animateEnable: false,
}

/**
 * Form.Item样式
 */
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
}
export const formItemLayout2 = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
}

/**
 * 报错不提示报错信息的白名单列表
 */
export const noErrorList = [
  {
    isNeedPhone: true,
    url: `${API_AUTH}/v1/admin/industry/users/by-phone/`,
  },
]

/**
 * 固定颜色集合
 */
export const fixedColors = [
  "#00FFFF",
  "#00FF8E",
  "#BEFF42",
  "#FFE500",
  "#FFA300",
  "#FD5A00",
  "#FF0061",
  "#E600C7",
  "#BE74FF",
  "#7A78FF",
  "#029E72",
  "#A04E50",
]

/**
 * 图表颜色集合
 */
export const CHART_COLORS = [
  "#00A9F7",
  "#00FFC2",
  "#72E1D7",
  "#3CB1DD",
  "#437CE0",
  "#3040D5",
  "#AC4AEE",
  "#CE4B6C",
]

/**
 * POI列表默认tags
 */
export const poiTagIds = false
  ? [
      "400009002", // 住宅（1级）
      "-1", // 公司企业（1级）
      "400009003", // 大厦
      "400009006", // 厂区
      "400009021", // 机场
      "400009022", // 车站
      "400009034", // 汽车4S
      "400010093", // 生活服务-金融-银行（3级）
      "400009068", // 学校（1级）
      "400009082", // 综合医院
      "400009083", // 专科医院
      "400009094", // 政府机关
    ]
  : [
      "10202", // 住宿-住宅-小区
      "20000", // 企业商务
      "50106", // 交通出行-机场-通用机场
      "50201", // 交通出行-车站-火车站
      "50202", // 交通出行-车站-地铁站
      "50203", // 交通出行-车站-长途汽车站
      "50204", // 交通出行-车站-公交站
      "51400", // 交通出行-汽车4S
      "60101", // 生活服务-金融-银行
      "80101", // 科教文化-学校-高等院校
      "80102", // 科教文化-学校-中学
      "80103", // 科教文化-学校-小学
      "80104", // 科教文化-学校-幼儿园
      "80105", // 科教文化-学校-成人教育
      "80106", // 科教文化-学校-特殊教育
      "80107", // 科教文化-学校-职业技术学校
      "90100", // 健康医疗保健-综合医院
      "90201", // 健康医疗保健-专科医院-整形美容
      "90202", // 健康医疗保健-专科医院-口腔医院
      "90203", // 健康医疗保健-专科医院-眼科医院
      "90204", // 健康医疗保健-专科医院-耳鼻喉科医院
      "90205", // 健康医疗保健-专科医院-胸科医院
      "90206", // 健康医疗保健-专科医院-骨科医院
      "90207", // 健康医疗保健-专科医院-肿瘤医院
      "90208", // 健康医疗保健-专科医院-脑科医院
      "90209", // 健康医疗保健-专科医院-妇科医院
      "90210", // 健康医疗保健-专科医院-男科医院
      "90211", // 健康医疗保健-专科医院-儿科医院
      "90212", // 健康医疗保健-专科医院-妇幼医院
      "90213", // 健康医疗保健-专科医院-精神病医院
      "90214", // 健康医疗保健-专科医院-传染病医院
      "100101", // 国家政府-政府机关-中央政府机关
      "100102", // 国家政府-政府机关-省级政府机关
      "100103", // 国家政府-政府机关-市级政府机关
      "100104", // 国家政府-政府机关-区县级机关
      "100105", // 国家政府-政府机关-乡镇级机关
      "100106", // 国家政府-政府机关-村级单位
    ]

/**
 * /v1/industry/poiNearby接口使用aoiPolygon的小区类型名称
 */
export const usedPolygonName = false ? "小区" : "住宅"

/**
 * /v1/industry/poiNearby接口（poiDetailList->categoryType）
 */
export const poiCategoryTypes = {
  company: "enterprise", // 公司
  community: "estate", // 小区
  factory: "factory_area", // 厂区
}

/**
 * /v1/industry/pointProfile接口（ecoType）
 */
export const poiEcoTypes = {
  company: "COMPANY", // 公司
  community: "RESIDENTIAL", // 小区
  factory: "FACTORY_AREA", // 厂区
}

/**
 * chart主题颜色公共样式
 */
export const commonChartStyle = {
  axisLabel: {
    fontSize: "0.9rem",
  },
  dark: {
    barBgColor: "rgb(31, 65, 140)",
  },
  light: {
    barBgColor: "#334262",
  },
}

export const chartDarkStyle = {
  Bar1: {
    style: {
      color: "#9FC2F1",
      fontSize: commonChartStyle.axisLabel.fontSize,
      marginTop: "1rem",
      height: 200,
    },
    barBackground: commonChartStyle.dark.barBgColor,
  },
  Border1: {
    backgroundColor: ["rgba(0, 63, 109, 1)", "rgba(0, 18, 64, 1)"],
    borderColor: "rgba(0, 110, 255, 0.4)",
    cornerColor: "rgba(0, 244, 237, 1)",
  },
  Header1: {
    borderColor: "#05fccc",
    backgroundColor: ["rgba(0, 91, 156, 0.2)", "rgba(6, 21, 29, 1)", "rgba(0, 79, 149, 0.4)"],
  },
  MapCircleLayer: {
    stroke: "rgb(0, 255, 196)",
    color: "rgb(0, 255, 196)",
    fillOpacity: 0.06,
  },
  // 雷达图表
  radar: {
    // 线条颜色
    lineColor: "rgb(255 255 255 / 20%)",
  },
  legend: {
    itemGap: 10,
    textStyle: {
      width: 100,
      color: "#9FC2F1",
      fontSize: commonChartStyle.axisLabel.fontSize,
      padding: [0, 5],
    },
  },
  xAxis: {
    axisLabel: {
      color: "#9FC2F1",
      fontSize: commonChartStyle.axisLabel.fontSize,
    },
  },
  yAxis: {
    axisLabel: {
      color: "#9FC2F1",
      fontSize: commonChartStyle.axisLabel.fontSize,
    },
  },
  others: {
    // 柱状图条柱背景色
    barBgColor: commonChartStyle.dark.barBgColor,
    // 文字颜色
    textColor: "#fff",
    // 默认字体颜色
    defaultTextColor: "#fff",
    // 高亮颜色
    textHighlightColor: "rgb(0 244 237)",
  },
}

export const chartLightStyle = {
  Bar1: {
    style: {
      color: "#fff",
      fontSize: commonChartStyle.axisLabel.fontSize,
      marginTop: "1rem",
      height: 200,
    },
    barBackground: commonChartStyle.light.barBgColor,
  },
  Border1: {
    backgroundColor: "transparent",
    borderColor: "rgba(255, 255, 255, 0.15)",
    cornerColor: "#1890ff",
  },
  Header1: {
    borderColor: "#2878ff",
    backgroundColor: "#1890ff",
  },
  MapCircleLayer: {
    stroke: "rgb(24, 144, 255)",
    color: "rgb(24, 144, 255)",
    fillOpacity: 0.1,
  },
  // 雷达图表
  radar: {
    // 线条颜色
    lineColor: "rgb(255 255 255 / 20%)",
  },
  legend: {
    itemGap: 10,
    textStyle: {
      width: 100,
      color: "#fff",
      fontSize: commonChartStyle.axisLabel.fontSize,
      padding: [0, 5],
    },
  },
  xAxis: {
    axisLabel: {
      color: "#fff",
      fontSize: commonChartStyle.axisLabel.fontSize,
    },
  },
  yAxis: {
    axisLabel: {
      color: "#fff",
      fontSize: commonChartStyle.axisLabel.fontSize,
    },
  },
  others: {
    // 柱状图条柱背景色
    barBgColor: commonChartStyle.light.barBgColor,
    // 文字颜色
    textColor: "#fff",
    // 默认字体颜色
    defaultTextColor: "#3e527f",
    // 高亮颜色
    textHighlightColor: "rgb(81, 128, 255)",
  },
}

/**
 * 金融、品牌的菜单
 */
export const headerTabs: any[] = [
  {
    label: "经营情况",
    value: IndustryModuleType.YE_JI,
    path: "indicator",
  },
  {
    label: "网点分析",
    value: IndustryModuleType.WANG_DIAN,
    path: "analysis",
    icon: require("@/assets/header/menus/house.svg").default,
  },
  {
    label: "周边生态",
    value: IndustryModuleType.HUO_KE,
    path: "eco",
    icon: require("@/assets/header/menus/bar.svg").default,
  },
  {
    label: "区域洞察",
    value: IndustryModuleType.AREA_INSIGHTS,
    path: "region-insight",
    icon: require("@/assets/header/menus/house.svg").default,
  },
  {
    label: "场景拓客",
    value: IndustryModuleType.XUN_KE,
    path: "mall",
    icon: require("@/assets/header/menus/house.svg").default,
  },
  {
    label: "客群提升",
    value: IndustryModuleType.YING_XIAO,
    path: "marketing",
  },
  {
    label: "智能选址",
    value: IndustryModuleType.XUAN_ZHI,
    path: "selection",
    icon: require("@/assets/header/menus/house.svg").default,
  },
  {
    label: "智能选址",
    value: IndustryModuleType.SITE_SELECTION,
    path: "starbucksSelection",
  },
  {
    label: "网格洞察",
    value: IndustryModuleType.INSIGHTS,
    path: "insights",
    icon: require("@/assets/header/menus/grid.svg").default,
  },
  {
    label: "门店对比",
    value: IndustryModuleType.STORE_COMPARISON,
    path: "relatively",
  },
  {
    label: "客情管理",
    value: IndustryModuleType.KE_QING,
    path: "situation",
  },
  {
    label: "竞品追踪",
    value: IndustryModuleType.ZHUI_ZONG,
    path: "competitor",
  },
  {
    label: "门店大盘",
    value: IndustryModuleType.SHOP_DASHBOARD,
    path: "guerlain",
    icon: require("@/assets/header/menus/house.svg").default,
  },
]

/**
 * 园区的菜单
 */
export const parkHeaderTabs = [
  {
    label: "地区概况",
    value: "DQGK",
    path: "area-overview",
  },
]

/**
 * 飞吉特的菜单
 */
export const feijiteHeaderTabs = [
  {
    label: "飞吉特首页",
    value: "INDEX",
    path: "feijite",
  },
]

/**
 * 按顺序排列的menu
 */
export const menuTabs = [
  { name: "商户", key: SceneCustomerType.BUSINESS },
  { name: "小区", key: SceneCustomerType.PROPERTY_COMPANY },
  { name: "企业", key: SceneCustomerType.COMPANY },
  { name: "农村", key: SceneCustomerType.RURAL_AREA },
  { name: "公共事业", key: SceneCustomerType.GOVERNMENT },
  { name: "专精特新", key: SceneCustomerType.SPECIALIZATION },
  { name: "大数据中心", key: SceneCustomerType.BIG_DATA_CENTER },
]

// 场景类型
export const sceneTypeTabs = [
  {
    label: "企业",
    value: SceneCustomerType.COMPANY,
    disabled: true,
    serviceTypes: [
      { name: "不限", type: "ALL" },
      { name: "专精特新", type: "SPECIAL" },
    ],
  },
  {
    label: "商户",
    value: SceneCustomerType.BUSINESS,
    disabled: true,
    serviceTypes: [{ name: "不限", type: "ALL" }],
  },
  {
    label: "小区",
    value: SceneCustomerType.PROPERTY_COMPANY,
    disabled: true,
    serviceTypes: [{ name: "不限", type: "ALL" }],
  },
  {
    label: "公共服务",
    value: SceneCustomerType.GOVERNMENT,
    disabled: true,
    serviceTypes: [{ name: "不限", type: "ALL" }],
  },
  {
    label: "农村",
    value: SceneCustomerType.RURAL_AREA,
    disabled: true,
    serviceTypes: [{ name: "不限", type: "ALL" }],
  },
]

/**
 * 商户状态
 */
export const cooStatus = [
  { text: "已合作", value: BusinessCooStatus.COOPERATION },
  { text: "未合作", value: BusinessCooStatus.NO_COOPERATION },
]

export const businessStatus = [
  { text: "未合作", value: BusinessCooStatus.NO_COOPERATION },
  { text: "已合作", value: BusinessCooStatus.COOPERATION },
  { text: "已建联", value: BusinessCooStatus.CONTACT },
]

/**
 * 商户各种业务状态类型
 */
export const businessTypes = [
  {
    value: BusinessCooMode.DEPOSIT,
    label: "存款",
    ringColor: ["#00E9FF", "#007DFF"],
  },
  {
    value: BusinessCooMode.LOAN,
    label: "贷款",
    ringColor: ["#FA6464", "#FF7288"],
  },
  {
    value: BusinessCooMode.CREDIT_CARD,
    label: "信用卡",
    ringColor: ["#6DE084", "#3BBD4D"],
  },
  {
    value: BusinessCooMode.BUSINESS,
    label: "收单",
    ringColor: ["#FFA738", "#FF6E1A"],
  },
  {
    value: BusinessCooMode.SALARY,
    label: "工资代发",
    ringColor: ["#00FFD4", "#00FFA9"],
  },
]

/**
 * 房屋均价
 */
export const housePrice = [
  { value: "[]", label: "不限" },
  { value: "[0, 2]", label: "2万以下" },
  { value: "[2, 4]", label: "2-4万" },
  { value: "[4, 6]", label: "4-6万" },
  { value: "[6, 8]", label: "6-8万" },
  { value: "[8, 10]", label: "8-10万" },
  { value: "[10, 100000000]", label: "大于等于10万" },
]

/**
 * 注册资本
 */
export const capitalRange = [
  { value: "[]", label: "不限" },
  { value: "[0, 100]", label: "100万以下" },
  { value: "[100, 200]", label: "100-200万" },
  { value: "[200, 500]", label: "200-500万" },
  { value: "[500, 1000]", label: "500-1000万" },
  { value: "[1000, 5000]", label: "1000-5000万" },
  { value: "[5000, 100000000]", label: "5000万以上" },
]

/**
 * 注册时间
 */
const today = getFormatDate(new Date(), "YYYY-MM-DD")
const date1 = getPrevOrNextDate(new Date(), -365, "YYYY-MM-DD")
const date3 = getPrevOrNextDate(new Date(), -365 * 3, "YYYY-MM-DD")
const date5 = getPrevOrNextDate(new Date(), -365 * 5, "YYYY-MM-DD")
const date10 = getPrevOrNextDate(new Date(), -365 * 10, "YYYY-MM-DD")
export const capitalDateRange = [
  { value: "[]", label: "不限" },
  { value: `["${date1}", "${today}"]`, label: "成立1年内" },
  { value: `["${date3}", "${date1}"]`, label: "成立1-3年" },
  { value: `["${date5}", "${date3}"]`, label: "成立3-5年" },
  { value: `["${date10}", "${date5}"]`, label: "成立5-10年" },
  { value: `["1900-01-01", "${date10}"]`, label: "成立10年以上" },
]

/**
 * 联系方式
 */
export const cppRecommend = [
  { value: "", label: "不限" },
  { value: CompanyPriorityRecommendType.PHONE, label: "有联系方式" },
  // { value: CompanyPriorityRecommendType.NONE, label: "无联系方式" },
]

/**
 * 政府机构
 */
export const government = [
  { value: "", label: "政府机构不限" },
  { value: GovQueryType.CENTRAL_GOV, label: "中央政府机关" },
  { value: GovQueryType.PROVINCE_GOV, label: "省级政府机关" },
  { value: GovQueryType.CITY_GOV, label: "市政府机关" },
  { value: GovQueryType.DISTRICT_GOV, label: "区县政府机关" },
  { value: GovQueryType.VILLAGE_GOV, label: "乡政府机关" },
  { value: GovQueryType.RURAL_GOV, label: "村级单位" },
]

/**
 * 工商税务机构
 */
export const taxation = [
  { value: "", label: "工商税务机构不限" },
  { value: CommerceTaxQueryType.STATE_TAX, label: "国税机关" },
  { value: CommerceTaxQueryType.LOCAL_TAX, label: "地税机关" },
  { value: CommerceTaxQueryType.COMMERCE, label: "工商部门" },
]

/**
 * 融资轮次
 */
export const financingRounds = [
  { value: FinancingRoundsType.ALL, label: "不限" },
  { value: FinancingRoundsType.A, label: "A轮" },
  { value: FinancingRoundsType.B, label: "B轮" },
  { value: FinancingRoundsType.C, label: "C轮" },
  { value: FinancingRoundsType.D, label: "D轮" },
  { value: FinancingRoundsType.E, label: "E轮" },
  { value: FinancingRoundsType.F, label: "F轮" },
  { value: FinancingRoundsType.LISTED, label: "上市公司" },
  { value: FinancingRoundsType.OTHER, label: "其他" },
]

/**
 * 农村模块行业取值范围
 */
export const ruralIndustryRange = [
  { id: "H0000", name: "住宿和餐饮业" },
  { id: "A0000", name: "农、林、牧、渔业" },
  { id: "C0000", name: "制造业" },
]

/**
 * 政府模块分类取值范围
 */
export const governmentIndustryRange = [
  {
    id: "all",
    name: "政府机构及团体",
    children: [
      {
        id: "government",
        name: "政府机关",
        children: [
          {
            id: GovQueryType.CENTRAL_GOV,
            name: "中央政府机关",
            children: [],
          },
          {
            id: GovQueryType.PROVINCE_GOV,
            name: "省级政府机关",
            children: [],
          },
          {
            id: GovQueryType.CITY_GOV,
            name: "市级政府机关",
            children: [],
          },
          {
            id: GovQueryType.DISTRICT_GOV,
            name: "区县级机关",
            children: [],
          },
          {
            id: GovQueryType.VILLAGE_GOV,
            name: "乡镇级机关",
            children: [],
          },
          {
            id: GovQueryType.RURAL_GOV,
            name: "村级单位",
            children: [],
          },
        ],
      },
      {
        id: "taxation",
        name: "工商税务机构",
        children: [
          {
            id: CommerceTaxQueryType.STATE_TAX,
            name: "国税机关",
            children: [],
          },
          {
            id: CommerceTaxQueryType.LOCAL_TAX,
            name: "地税机关",
            children: [],
          },
          {
            id: CommerceTaxQueryType.COMMERCE,
            name: "工商部门",
            children: [],
          },
        ],
      },
    ],
  },
]

/**
 * 用户维护的商户状态
 */
export const storeStatusForUser = [
  { value: "营业中", label: "营业中" },
  { value: "已关闭", label: "已关闭" },
]

// 主题颜色
export const themes = [
  { value: "light", src: require("@/assets/header/theme-light.png") },
  { value: "dark", src: require("@/assets/header/theme-dark.png") },
]

// 系统配置-菜单
export const authMenuList = isNH
  ? [
      { value: "userOrg", label: "用户管理" },
      { value: "role", label: "角色管理" },
    ]
  : [
      { value: "overview", label: "概览" },
      { value: "userOrg", label: "用户管理" },
      { value: "role", label: "角色管理" },
      { value: "dataAuth", label: "数据权限" },
    ]

export const countList = [
  { key: "userOrg", value: 0, label: "用户数" },
  { key: "org", value: 0, label: "组织数" },
  { key: "role", value: 0, label: "角色数" },
]

// 系统配置-概览
export const descriptionList = [
  {
    index: "1",
    title: "创建用户",
    content: "您可以通过链接的方式邀请同事或将同事名单手动录入到系统中",
  },
  {
    index: "2",
    title: "创建角色",
    content:
      "您可以通过创建角色来管理您的多个用户，例如您可以创建管理员、运营人员等不同的用户角色，从而赋予不同的权限",
  },
  // {
  //   index: "3",
  //   title: "创建组织",
  //   content: "您可以通过创建组织将用户分群",
  // },
]

// 系统配置-角色权限
export const roleAuthList = [
  {
    value: RoleAuthStrategy.INDUSTRY_DATA_AUTHORITY,
    name: "沙盘数据读取编辑权限",
    desc: "场景拓客商户等信息录入权限",
  },
  {
    value: RoleAuthStrategy.MULTI_USER_OPERATION,
    name: "多用户操作权限",
    desc: "新老用户添加编辑等权限",
  },
]

// 系统配置-用户管理
export const companySearchTypes = [
  { value: "org", label: "部门查询" },
  { value: "user", label: "成员查询" },
]

// 客流类型
export const flowFilterTypes = [
  { name: "到访指数前", id: FlowFilterType.VISIT_RATIO },
  { name: "常驻指数前", id: FlowFilterType.RESIDENT_RATIO },
]

// 客流单位
export const flowFilterUnits = [
  { name: "%", id: FlowFilterUnit.PERCENT },
  { name: "名", id: FlowFilterUnit.TOP },
]

// 拜访记录-时间段查询
export const visitTimeTypes = [
  { value: "", label: "自定义时间筛选" },
  { value: "7", label: "最近一周" },
  { value: "15", label: "最近半个月" },
  { value: "90", label: "最近三个月" },
  { value: "180", label: "最近半年" },
]

// 智能选址-分析时间
const dateWeek = getPrevOrNextDate(new Date(), -7, "YYYY-MM-DD")
const dateMonth1 = getPrevOrNextDate(new Date(), -30, "YYYY-MM-DD")
const dateMonth3 = getPrevOrNextDate(new Date(), -90, "YYYY-MM-DD")
const dateMonth6 = getPrevOrNextDate(new Date(), -180, "YYYY-MM-DD")
export const parsingTimeTypes = [
  { value: "[]", label: "不限" },
  { value: `["${dateWeek}", "${today}"]`, label: "最近一周" },
  { value: `["${dateMonth1}", "${today}"]`, label: "最近一个月" },
  { value: `["${dateMonth3}", "${today}"]`, label: "最近三个月" },
  { value: `["${dateMonth6}", "${today}"]`, label: "最近半年" },
]

// 智能选址-状态
export const analysisStatus = [
  { value: "", label: "全部状态" },
  { value: SiteAnalysisStatus.ANALYSING, label: "分析中" },
  { value: SiteAnalysisStatus.ANALYSE_FAILURE, label: "分析失败" },
  { value: SiteAnalysisStatus.ANALYSE_SUCCESS, label: "分析完成" },
]

// 客情管理-部门级联
export const departmentOptions = [
  {
    id: "A大组",
    name: "A大组",
    children: [
      {
        id: "B中组",
        name: "B中组",
        children: [
          {
            id: "C小组",
            name: "C小组",
          },
          {
            id: "D小组",
            name: "D小组",
            children: [
              {
                id: "1",
                name: "1",
              },
              {
                id: "2",
                name: "2",
              },
            ],
          },
        ],
      },
      {
        id: "a",
        name: "a",
      },
      {
        id: "b",
        name: "b",
      },
      {
        id: "c",
        name: "c",
      },
    ],
  },
  {
    id: "A大组-2",
    name: "A大组-2",
    children: [
      {
        id: "B中组-2",
        name: "B中组-2",
        children: [
          {
            id: "C小组-2",
            name: "C小组-2",
          },
          {
            id: "D小组-2",
            name: "D小组-2",
          },
        ],
      },
    ],
  },
  {
    id: "A大组-3",
    name: "A大组-3",
    children: [
      {
        id: "B中组-3",
        name: "B中组-3",
        children: [
          {
            id: "C小组-3",
            name: "C小组-3",
          },
          {
            id: "D小组-3",
            name: "D小组-3",
          },
        ],
      },
    ],
  },
]

// 客情管理-Card
export const rateCards = [
  {
    key: "storeRatio",
    title: "门店达标率",
    count: 0,
    tips: "时间范围内，总体门店达标率=目标人群的达标率相加/目标人数",
  },
  {
    key: "durationRatio",
    title: "拜访时长达标率",
    count: 0,
    tips: "时间范围内，总体拜访时长达标率=目标人群拜访时长达标率相加/目标人数",
  },
  {
    key: "visitCountRatio",
    title: "拜访频次达标率",
    count: 0,
    tips: "时间范围内，总体拜访频次达标率=目标人群拜访频次达标率相加/目标人数",
  },
  {
    key: "averageDuration",
    title: "门店平均拜访时长",
    count: 0,
    tips: "时间范围内，总体门店平均拜访时长=目标人群门店平均拜访时长相加/目标人数",
  },
]

// 智能选址
export const selectionTabs = [
  { value: SiteChooseWay.SYSTEM_RECOMMEND, label: "智能推荐" },
  { value: SiteChooseWay.SITE_SCORE, label: "专家经验" },
]

// 星巴克demo
export const starbucksTabs = [
  { value: SiteChooseWay.SYSTEM_RECOMMEND, label: "智能推荐" },
  { value: "optional", label: "自选推荐" },
]

// 推荐星级
export const starLevels = [
  { value: "[]", label: "不限" },
  { value: "[0.8, 1]", label: "4-5星" },
  { value: "[0.4, 0.8]", label: "2-3星" },
  { value: "[0, 0.4]", label: "0-1星" },
]

// 半径范围
export const radiusScopeList = [
  { value: 100, label: "100m范围内" },
  { value: 150, label: "150m范围内" },
  { value: 500, label: "500m范围内" },
  { value: 1000, label: "1KM范围内" },
]

// 条件范围
export const conditionScopeList = [
  { value: SiteSelectionRestrictionCondition.QUANITTY_LTE, label: "数量小于等于" },
  { value: SiteSelectionRestrictionCondition.QUANITTY_LT, label: "数量小于" },
  { value: SiteSelectionRestrictionCondition.QUANITTY_GTE, label: "数量大于等于" },
  { value: SiteSelectionRestrictionCondition.QUANITTY_GT, label: "数量大于" },
]

// 经营情况
export const indicatorMenus = [
  {
    value: PerformanceCustomerType.FEN_XI,
    label: "综合分析",
    icon: require("@/assets/page-indicator/analysis.svg").default,
  },
  {
    value: PerformanceCustomerType.GAI_LAN,
    label: "网点概览",
    icon: require("@/assets/page-indicator/overview.svg").default,
  },
  {
    value: PerformanceCustomerType.JING_YING,
    label: "经营指标",
    icon: require("@/assets/page-indicator/manage.svg").default,
  },
  {
    value: PerformanceCustomerType.CHAN_PIN,
    label: "产品指标",
    icon: require("@/assets/page-indicator/product.svg").default,
  },
  {
    value: PerformanceCustomerType.DUI_GONG,
    label: "对公客户",
    icon: require("@/assets/page-indicator/public.svg").default,
  },
  {
    value: PerformanceCustomerType.GE_REN,
    label: "个人客户",
    icon: require("@/assets/page-indicator/personal.svg").default,
  },
]

// 网点类型
export const branchTypes = [
  { value: "coreType", label: "核心" },
  { value: "baboType", label: "骨干" },
  { value: "lightType", label: "轻型" },
]

// 网点定位
export const branchPositions = [
  { value: "faucetCategory", label: "龙头型" },
  { value: "marketCategory", label: "市场型" },
  { value: "communityCategory", label: "社区型" },
  { value: "townshipCategory", label: "乡镇型" },
  { value: "parkCategory", label: "园区型" },
  { value: "businessCategory", label: "商圈型" },
]

// 是否智慧网点
export const whetherOrNotInteli = [
  { value: "1", label: "是智慧网点" },
  { value: "0", label: "非智慧网点" },
]

// 区县边界颜色条
export const polygonHeatColors = [
  "rgba(12, 235, 138, 0.6)",
  "rgba(12, 235, 181, 0.6)",
  "rgba(12, 235, 225, 0.6)",
  "rgba(12, 199, 235, 0.6)",
  "rgba(12, 181, 235, 0.6)",
  "rgba(12, 153, 235, 0.6)",
]

type Item = {
  key: string //
  tagId: string | number
  tagKey: string
  echarts: any
  className?: string //特殊的类
  value?: string | number
  color?: any[]
  top?: number //展示top多少
  flex?: boolean //大于5条显示一行
}
type GridTagItem = {
  tagKey: string
  key: string
  children: Item[] | any
}

export const populationConf: any = {
  visit: {
    id: "10",
    name: "到访人口数",
  },
  resident: {
    id: "3",
    name: "常驻人口数",
  },
  live: {
    id: "1",
    name: "居住人口数",
  },
  work: {
    id: "2",
    name: "工作人口数",
  },
}
export const gridCate: any = {
  写字楼: {
    name: "写字楼",
    icon: office,
    categoryId: 20201,
  },
  商场: {
    name: "商场",
    icon: market,
    categoryId: 40100,
  },
  国家政府: {
    name: "国家政府",
    icon: governmentImg,
  },
  小区: {
    name: "小区",
    icon: quarters,
    categoryId: 10200,
  },
  医院: {
    name: "医院",
    icon: hospital,
    categoryId: 90100,
  },
  交通: {
    name: "交通",
    icon: traffic,
    categoryId: 50000,
  },
  酒店: {
    name: "酒店",
    icon: hotel,
    categoryId: 10100,
  },
  学校: {
    name: "学校",
    icon: school,
    categoryId: 80100,
  },
  园区: {
    name: "园区",
    icon: park,
    categoryId: 20901,
  },
}

export const CHATGPT_KEY = "chatgpt"

export const gridTagConf: GridTagItem[] = [
  {
    tagKey: "基础属性",
    key: "base",
    children: [
      { key: "gender", tagKey: "性别", tagId: "102001", echarts: BarSex },
      { key: "consumeLevel", tagKey: "消费水平", tagId: "105001", echarts: BarPercent },
      { key: "age", tagKey: "年龄", tagId: "102002", echarts: Pie },
      { key: "property", tagKey: "资产情况", tagId: "105002", echarts: PieMore },
    ],
  },
  {
    tagKey: "人口地理",
    key: "geography",
    children: [
      //行为偏好
      { key: "118001", tagKey: "行为偏好-购物", tagId: "118001", echarts: Bar, flex: true },
      { key: "118002", tagKey: "行为偏好-景区", tagId: "118002", echarts: BarPercent, flex: true },
      { key: "118003", tagKey: "行为偏好-学校", tagId: "118003", echarts: Pie },
      { key: CHATGPT_KEY, tagKey: "GPT洞察", tagId: CHATGPT_KEY, echarts: Chatgpt },
      { key: "118004", tagKey: "行为偏好-健康医疗", tagId: "118004", echarts: BarRow, flex: true },
      { key: "118005", tagKey: "行为偏好-汽车", tagId: "118005", echarts: PieHalf },
      {
        key: "118006",
        tagKey: "行为偏好-基础设施",
        tagId: "118006",
        echarts: Bar,
        flex: true,
        color: BarColor[0],
      },
      {
        key: "118007",
        tagKey: "行为偏好-酒店宾馆",
        tagId: "118007",
        echarts: Bar,
        flex: true,
        color: BarColor[1],
      },
      {
        key: "118008",
        tagKey: "行为偏好-休闲",
        tagId: "118008",
        echarts: BarPercent,
        flex: true,
        color: BarTopColor[0],
      },
      { key: "118009", tagKey: "行为偏好-运动", tagId: "118009", echarts: BarPercent, flex: true },
      { key: "118010", tagKey: "行为偏好-餐饮", tagId: "118010", echarts: BarRow, flex: true },
      {
        key: "118011",
        tagKey: "行为偏好-公司企业",
        tagId: "118011",
        echarts: BarPercent,
        flex: true,
      },
      {
        key: "118012",
        tagKey: "行为偏好-金融服务",
        tagId: "118012",
        echarts: PieHalf,
        color: BarColor[0],
      },
      { key: "118013", tagKey: "行为偏好-社会团体", tagId: "118013", echarts: PieMore },
      {
        key: "118014",
        tagKey: "行为偏好-生活服务",
        tagId: "118014",
        echarts: BarTop,
        color: BarTopColor[0],
        flex: true,
      },
      { key: "118015", tagKey: "行为偏好-政府机构", tagId: "118015", echarts: Bar, flex: true },
      { key: "118016", tagKey: "行为偏好-居住", tagId: "118016", echarts: PieHalf },
      {
        key: "118017",
        tagKey: "周末购物特征",
        tagId: "118017",
        echarts: Bar,
        flex: true,
        color: BarColor[0],
      },
      { key: "118018", tagKey: "周末娱乐特征", tagId: "118018", echarts: BarPercent, flex: true },
    ],
  },
  {
    tagKey: "设备应用",
    key: "device",
    children: [
      {
        key: "preferAndRequired",
        tagKey: "偏好与需求",
        tagId: "107010",
        echarts: TreeMap,
        top: true,
      },
    ],
  },
]

// 省市置换
export const provincesReplace = {
  // 北京市
  110000: 110100,
  // 天津市
  120000: 120100,
  // 上海市
  310000: 310100,
  // 重庆市
  500000: 500100,
  // 香港
  810000: 810100,
  // 澳门
  820000: 820100,
}

// 特殊地区: 台湾
export const specialAreas = [710000]

// 行业类型兜底图片
export const emptyIconNames = {
  // 美食
  B01: "catering",
  // 购物
  B02: "shopping",
  // 休闲/娱乐
  B05: "leisure",
  // 美容/塑形
  B07: "beauty",
  // 生活服务
  B11: "service",
  // 金融服务
  B12: "bank",
}
